// @flow

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import './i18n';

import 'core/config';
import authorize from 'services/oauth2';
import AirBrakeNotifier from 'components/AirBrakeNotifier';
import GlobalStyle from 'styles/global';
import stores from 'core/stores';

import App from 'apps';

authorize();

const root = document.getElementById('root');

if (root == null) {
  throw new Error('No root element');
}

ReactDOM.render(
  <AirBrakeNotifier>
    <Provider {...stores}>
      <GlobalStyle />
      <App />
    </Provider>
  </AirBrakeNotifier>,
  root
);
